export const getFormData = (data) => {
  const formData = new FormData();
  if (data.file) formData.append('original', data.file);
  if (typeof data.position === 'number' && !isNaN(data.position))
    formData.append('position', data.position);
  if (data.units) formData.append('units', data.units);
  if (typeof data.thickness === 'number' && !isNaN(data.thickness))
    formData.append('thickness', data.thickness);
  if (data.processId) formData.append('process_id', data.processId);
  if (data.materialId) formData.append('material_id', data.materialId);
  if (data.supplierMaterialId)
    formData.append('supplier_material_id', data.supplierMaterialId);
  if (data.finishOpDefIds)
    formData.append('finish_op_def_ids', data.finishOpDefIds);
  if (data.exportControlled)
    formData.append('export_controlled', data.exportControlled);
  if (data.estimatorId) formData.append('estimator_id', data.estimatorId);
  if (data.quantities) formData.append('quantities', data.quantities);
  if (data.bomQuantity) formData.append('bom_quantity', data.bomQuantity);
  if (data.parentComponentId)
    formData.append('parent_component_id', data.parentComponentId);
  if (data.isAssembly) formData.append('is_assembly', data.isAssembly);
  if (data.partNumber) formData.append('part_number', data.partNumber);
  if (data.revision) formData.append('revision', data.revision);
  return formData;
};
